import { COLORS, SPACING } from '@/presentation/theme/tokens';

export const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(8,8,16,0.78)',
  display: 'grid',
  placeItems: 'center',
  zIndex: 200,
  padding: SPACING.md,
};

export const cardStyle: React.CSSProperties = {
  background: '#14142a',
  border: '3px solid #ffd6b3',
  borderRadius: 0,
  padding: SPACING.xl,
  maxWidth: 480,
  width: '100%',
  maxHeight: '85vh',
  overflow: 'auto',
  color: COLORS.text,
  boxShadow: '0 0 0 2px #0a0a14, 6px 6px 0 rgba(0,0,0,0.45)',
  imageRendering: 'pixelated',
};

export const closeBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: COLORS.textDim,
  fontSize: 24,
  cursor: 'pointer',
  position: 'absolute',
  top: SPACING.sm,
  right: SPACING.md,
};
